export const MIN_SEARCH_LENGTH = 3;

const normalizeSearchValue = (value = '') => value.trim();

export const shouldTriggerSearchRequest = (value, minLength = MIN_SEARCH_LENGTH) => {
  const normalizedValue = normalizeSearchValue(value);
  return normalizedValue.length === 0 || normalizedValue.length >= minLength;
};

export const getActiveSearchTerm = (value, minLength = MIN_SEARCH_LENGTH) => {
  const normalizedValue = normalizeSearchValue(value);
  return normalizedValue.length >= minLength ? normalizedValue : '';
};
